import { Injectable } from '@angular/core';
import SweetAlert, { SweetAlertOptions } from 'sweetalert2';

import { UI_MENTION_COMMAND_KEYS, AtMentionCommands } from './at-mention.model';

@Injectable({
  providedIn: 'root',
})
export class AtMentionService {
  constructor() {}

  saveAfterConfirmation(text :string) {
    const needConfirmationKeys = this.needSavingConfirmation(text);
    if (needConfirmationKeys.length > 0) {
      return this.confirmNotifyCollaborators(needConfirmationKeys);
    }

    return new Promise((resolve, _reject) => {
      resolve({});
    });
  }

  private needSavingConfirmation(text :string) :AtMentionCommands[] {
    return UI_MENTION_COMMAND_KEYS.filter((key) => {
      return text.toLowerCase().includes(key);
    });
  }

  private getContributorsNotifyConfig(
    confirmationKeys :AtMentionCommands[],
  ) :SweetAlertOptions {
    let usedKeysMessage = '';
    confirmationKeys.forEach((key :AtMentionCommands, index :number) => {
      usedKeysMessage += index > 0 ? `, ${key}` : key;
    });
    const swalOpts :SweetAlertOptions = {};

    swalOpts.title = 'title';
    swalOpts.confirmButtonText = 'confirm text';
    swalOpts.cancelButtonText = 'cancel text';

    return swalOpts;
  }

  private confirmNotifyCollaborators(confirmationKeys :AtMentionCommands[]) :any {
    return SweetAlert.fire(this.getContributorsNotifyConfig(confirmationKeys));
  }
}
